<template>
	<div ref="slider" class="slider">
		<div class="slider__wrapper"
			:style="{ transform: `translateX(-${currentSlide * slideWidth}%)`, transition: `transform ${transitionDelay}s ease-in-out` }">
			<div ref="slides" :id="`slide-${index}`" class="slider__slide" v-for="(item, index) in doubledContent"
				:key="`slide-${item.flexKey}`">
				<SmallContentLink :content="item" />
			</div>
		</div>
	</div>
</template>

<script>
import { HasContentMixin } from '@/mixins'
import SmallContentLink from '@/components/small/SmallContentLink.vue'

export default {
	name: 'Slider',
	mixins: [HasContentMixin],
	components: {
		SmallContentLink
	},
	data() {
		return {
			currentSlide: 0,
			transitionDelay: 3,
			timer: null
		}
	},
	computed: {
		doubledContent() {
			return [...this.content, ...this.content]
		},
		slideWidth() {
			return 100 / 5
		},
	},
	methods: {
		nextSlide() {
			if (this.currentSlide < this.content.length) {
				this.currentSlide++
			} else {
				this.transitionDelay = 0
				this.currentSlide = 0
				setTimeout(() => {
					this.transitionDelay = 3
					this.currentSlide = 1
					this.setActive()
				}, 100)
			}
			this.setActive()
		},
		setActive() {
			if (!this.$refs.slides) return

			this.$refs.slides.forEach(slide => slide.classList.remove('--active'))

			const activeIndexes = [
				this.currentSlide + 2,
				this.currentSlide + 2 - this.content.length,
				this.currentSlide + 2 + this.content.length
			]

			activeIndexes.forEach(index => {
				if (this.$refs.slides[index]) {
					this.$refs.slides[index].classList.add('--active')
				}
			})
		}
	},
	mounted() {
		this.setActive()

		this.timer = setInterval(() => {
			this.nextSlide()
		}, 3500)
	},
	beforeUnmount() {
		clearInterval(this.timer)
	}
}
</script>
